<!-- Header -->
<ion-header
  class="ion-no-border"
  [class.ion-header-modal-desktop]="platform === PlatformEnum.desktop"
  [class.ion-header-modal-tablet]="platform === PlatformEnum.tablet"
  [class.ion-header-modal-mobile]="platform === PlatformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === PlatformEnum.desktop" slot="end">
      <ion-button data-cy="non-usf-close-button" (click)="dismiss()">
        <ion-icon
          data-cy="non-usf-close-button-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="non-usf-modal-title">
      {{
        (isEditMode
          ? 'i18n.nonUsfProducts.editNonUsfProductTitle'
          : 'i18n.nonUsfProducts.addNonUsfProductTitle'
        ) | translate
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<!-- Form Name -->
<ng-template #formName let-form="form">
  <ion-row data-cy="non-usf-name-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-name-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-name-label" for="name">
        {{ 'i18n.nonUsfProducts.nameFormTitle' | translate }}
        <span data-cy="non-usf-required-name-indicator-text" class="required">
          {{ 'i18n.common.requiredInputIndicator' | translate }}
        </span>
      </ion-label>

      <ion-item data-cy="non-usf-name-section">
        <ion-textarea
          data-cy="non-usf-name-input"
          formControlName="name"
          autoGrow="true"
          maxlength="75"
          minlength="1"
          placeholder="{{ 'i18n.nonUsfProducts.max75Char' | translate }}"
          required="true"
          rows="1"
          trimSpace
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Form Vendor -->
<ng-template #formVendor let-form="form">
  <ion-row data-cy="non-usf-vendor-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-vendor-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label
        data-cy="non-usf-vendor-label"
        for="vendor"
        [class.gray-out]="vendors.length === 0"
      >
        {{ 'i18n.nonUsfProducts.vendorForm' | translate }}
      </ion-label>

      <ion-item
        class="vendors clickable"
        data-cy="non-usf-vendor-section"
        detail="true"
        detail-icon="chevron-down-outline"
        [class.gray-out]="vendors.length === 0"
        (click)="onVendorClick($event)"
      >
        <ion-label
          data-cy="non-usf-vendor-inner-label"
          class="gray-out clickable"
          *ngIf="vendors.length === 0"
        >
          {{ 'i18n.nonUsfProducts.noVendorFound' | translate }}
        </ion-label>
        <ion-label
          class="clickable regular"
          data-cy="non-usf-vendor-inner-label"
          [class.regular]="usfProductForm.get('vendor').value"
          [class.gray-out-plus]="!usfProductForm.get('vendor').value"
          *ngIf="vendors.length > 0"
        >
          {{
            usfProductForm.get('vendor').value
              ? usfProductForm.get('vendor').value?.distributorName
              : ('i18n.nonUsfProducts.selectVendor' | translate)
          }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Form Brand -->
<ng-template #formBrand let-form="form">
  <ion-row data-cy="non-usf-brand-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-brand-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-brand-label" for="brand">
        {{ 'i18n.nonUsfProducts.brandForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-brand-section">
        <ion-textarea
          data-cy="non-usf-brand-input"
          formControlName="brand"
          autoGrow="true"
          maxlength="25"
          required="false"
          rows="1"
          placeholder="{{ 'i18n.nonUsfProducts.max25Char' | translate }}"
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
          trimSpace
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Form Manufacture -->
<ng-template #formManufacture let-form="form">
  <ion-row data-cy="non-usf-manufacture-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-manufacture-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-manufacture-label" for="manufacturerNum">
        {{ 'i18n.nonUsfProducts.manufacturerForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-manufacture-section">
        <ion-textarea
          data-cy="non-usf-manufacture-input"
          formControlName="manufacturerNum"
          autoGrow="true"
          maxlength="16"
          required="false"
          rows="1"
          trimSpace
          placeholder="{{ 'i18n.nonUsfProducts.max16Char' | translate }}"
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Form Pack Size -->
<ng-template #formPack let-form="form">
  <ion-row data-cy="non-usf-pack-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-pack-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-pack-label" for="packSize">
        {{ 'i18n.nonUsfProducts.packForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-pack-section">
        <ion-textarea
          data-cy="non-usf-pack-input"
          formControlName="packSize"
          autoGrow="true"
          maxlength="12"
          required="false"
          rows="1"
          placeholder="{{ 'i18n.nonUsfProducts.max12Char' | translate }}"
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
          trimSpace
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Form Net Weight -->
<ng-template #formNetWeight let-form="form">
  <ion-row data-cy="non-usf-net-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-net-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-net-label" for="avgNetWeight">
        {{ 'i18n.nonUsfProducts.netWeightForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-net-section">
        <ion-textarea
          data-cy="non-usf-net-input"
          formControlName="avgNetWeight"
          autoGrow="true"
          maxlength="12"
          required="false"
          rows="1"
          customDecimal
          [maxLeftHandDigits]="9"
          [maxPrecision]="2"
          placeholder="{{ 'i18n.nonUsfProducts.max12Char' | translate }}"
          (ionBlur)="weightUpdate()"
          (ionFocus)="inputFocus()"
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Form Price -->
<ng-template #formPrice let-form="form">
  <ion-row data-cy="non-usf-price-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-price-column"
      class="non-usf-action-column"
      size="7.5"
    >
      <ion-label data-cy="non-usf-price-label" for="price">
        {{ 'i18n.nonUsfProducts.priceForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-price-section">
        <ion-textarea
          data-cy="non-usf-price-input"
          formControlName="price"
          autoGrow="true"
          maxlength="12"
          required="false"
          rows="1"
          customDecimal
          [maxLeftHandDigits]="9"
          [maxPrecision]="2"
          placeholder="{{ 'i18n.nonUsfProducts.max12Char' | translate }}"
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
        >
        </ion-textarea>
      </ion-item>
    </ion-col>
    <ion-col size="4" offset="0.5">
      <div class="buffer"></div>
      <ion-item
        data-cy="non-usf-price-section"
        detail="true"
        detail-icon="chevron-down-outline"
        class="clickable"
        (click)="onPriceOptionClick($event)"
      >
        <ion-label
          data-cy="non-usf-price-option-label"
          for="priceOption"
          class="regular clickable"
        >
          {{ usfProductForm.get('priceOption').value }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #productNumber>
  <ion-row data-cy="non-usf-product-number-row">
    <ion-col
      data-cy="non-usf-product-number-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label>
        {{ 'i18n.nonUsfProducts.productForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-product-number-section">
        <ion-label class="gray-out">
          {{ originalProduct?.productNumber }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #unitDescription>
  <ion-row data-cy="non-usf-unit-description-row">
    <ion-col
      data-cy="non-usf-unit-description-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-unit-description-label">
        {{ 'i18n.nonUsfProducts.unitDescriptionForm' | translate }}
      </ion-label>
      <ion-item
        data-cy="non-usf-unit-description-section"
        class="clickable"
        (click)="onUnitsClick($event)"
        detail="true"
        detail-icon="chevron-down-outline"
      >
        <ion-label
          data-cy="non-usf-unit-description-option-label"
          class="regular clickable"
        >
          {{ usfProductForm.get('units').value }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #unitsPerCase let-form="form">
  <ion-row data-cy="non-usf-units-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-units-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-units-label" for="unitsPerCase">
        {{ 'i18n.nonUsfProducts.unitCaseForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-units-section">
        <ion-textarea
          data-cy="non-usf-units-input"
          formControlName="unitsPerCase"
          autoGrow="true"
          maxlength="3"
          required="false"
          rows="1"
          numeric
          placeholder="{{ 'i18n.nonUsfProducts.max3Char' | translate }}"
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #productYield let-form="form">
  <ion-row data-cy="non-usf-product-yield-row" [formGroup]="form">
    <ion-col
      data-cy="non-usf-product-yield-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-product-yield-label" for="productYield">
        {{ 'i18n.nonUsfProducts.productYieldForm' | translate }}
      </ion-label>
      <ion-item data-cy="non-usf-product-yield-section">
        <ion-textarea
          data-cy="non-usf-product-yield-input"
          formControlName="productYield"
          autoGrow="true"
          maxlength="3"
          required="false"
          rows="1"
          numericCapped
          placeholder="{{ 'i18n.nonUsfProducts.max3Char' | translate }}"
          (ionBlur)="inputBlur()"
          (ionFocus)="inputFocus()"
        ></ion-textarea>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #formPimClass>
  <ion-row data-cy="non-usf-pim-class-row">
    <ion-col
      data-cy="non-usf-pim-class-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label data-cy="non-usf-pim-class-label">
        {{ 'i18n.nonUsfProducts.pimClass' | translate }}
      </ion-label>
      <ion-item
        data-cy="non-usf-pim-class-section"
        class="clickable"
        (click)="goToPimSelection(PIMLevelEnum.class)"
        detail="true"
        detail-icon="chevron-forward-outline"
      >
        <ion-label
          class="clickable"
          data-cy="non-usf-pim-class-option-label"
          [class.regular]="pimClassHeirachy"
          [class.gray-out-plus]="!pimClassHeirachy"
        >
          {{
            pimClassHeirachy
              ? pimClassHeirachy.description
              : ('i18n.nonUsfProducts.pimClassChoose' | translate)
          }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #formPimCategory>
  <ion-row data-cy="non-usf-pim-category-row">
    <ion-col
      data-cy="non-usf-pim-category-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label
        data-cy="non-usf-pim-category-label"
        [class.gray-out-plus]="pimCategoryOptions.length === 0"
      >
        {{ 'i18n.nonUsfProducts.pimCategory' | translate }}
      </ion-label>
      <ion-item
        data-cy="non-usf-pim-category-section"
        class="clickable"
        (click)="goToPimSelection(PIMLevelEnum.category)"
        detail="true"
        detail-icon="chevron-forward-outline"
        [disabled]="pimCategoryOptions.length === 0"
      >
        <ion-label
          class="clickable"
          [class.regular]="pimCategoryHeirarchy"
          [class.gray-out-plus]="!pimCategoryHeirarchy"
          data-cy="non-usf-pim-category-option-label"
        >
          {{
            pimCategoryHeirarchy
              ? pimCategoryHeirarchy.description
              : ('i18n.nonUsfProducts.pimCategoryChoose' | translate)
          }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #formPimGroup>
  <ion-row data-cy="non-usf-pim-group-row">
    <ion-col
      data-cy="non-usf-pim-group-column"
      class="non-usf-action-column"
      size="12"
    >
      <ion-label
        data-cy="non-usf-pim-group-label"
        [class.gray-out-plus]="pimGroupOptions.length === 0"
      >
        {{ 'i18n.nonUsfProducts.pimGroup' | translate }}
      </ion-label>
      <ion-item
        data-cy="non-usf-pim-group-section"
        class="clickable"
        (click)="goToPimSelection(PIMLevelEnum.group)"
        detail="true"
        detail-icon="chevron-forward-outline"
        [disabled]="pimGroupOptions.length === 0"
      >
        <ion-label
          class="clickable"
          [class.regular]="pimGroupHeirarchy"
          [class.gray-out-plus]="!pimGroupHeirarchy"
          data-cy="non-usf-pim-group-option-label"
        >
          {{
            pimGroupHeirarchy
              ? pimGroupHeirarchy.description
              : ('i18n.nonUsfProducts.pimGroupChoose' | translate)
          }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #mppUnitsOfMeasure>
  <ng-template #notEnoughDataMeasure>
    <app-ingredient-units-of-measure
      class="push"
      [platform]="platform"
      [hideSaving]="true"
      [hidePricing]="true"
      [inLinePadding]="true"
      [disableInputs]="true"
      (infoIconEvent)="onMppInfoIconClick($event)"
    >
    </app-ingredient-units-of-measure>
  </ng-template>
  <ng-container
    *ngIf="mppCalculations$ | async as calculations; else notEnoughDataMeasure"
  >
    <app-ingredient-units-of-measure
      class="push"
      [platform]="platform"
      [baseUnit]="calculations?.displayBaseUnit"
      [baseQuantity]="calculations?.baseQuantity"
      [conversionUnit]="calculations?.displayConversionUnit"
      [conversionQuantity]="calculations?.conversionQunatity"
      [solvedUnit]="calculations?.displayTestUnit"
      [solvedQuantity]="calculations?.testQuantity"
      [solvedCost]="calculations?.testCost"
      [baseUnits]="calculations?.allowedUnits"
      [conversionUnits]="calculations?.possibleConversionUnits"
      [hideSaving]="true"
      [hidePricing]="true"
      [inLinePadding]="true"
      [disableInputs]="
        !calculations || !usfProductForm.get('avgNetWeight').value
      "
      (baseQuantityEvent)="onMppBaseQuantityChange($event)"
      (conversionQuantityEvent)="onMppConversionQuantityChange($event)"
      (baseUnitEvent)="onMppBaseUnitClick($event)"
      (conversionUnitEvent)="onMppConversionUnitClick($event)"
      (infoIconEvent)="onMppInfoIconClick($event)"
    >
    </app-ingredient-units-of-measure>
  </ng-container>
</ng-template>

<!-- ***** DESKTOP/TABLET ***** -->
<ng-template #formDesktop>
  <ion-row>
    <ion-col size="3.66">
      <ng-container
        *ngTemplateOutlet="formName; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formVendor; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formBrand; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col [size]="isEditMode ? 2.5 : 3.66">
      <ng-container
        *ngTemplateOutlet="formManufacture; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col *ngIf="isEditMode" size="2.5" offset="0.5">
      <ng-container *ngTemplateOutlet="productNumber"></ng-container>
    </ion-col>
    <ion-col [size]="isEditMode ? 2.5 : 3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formPack; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="isEditMode ? 2.5 : 3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formNetWeight; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="4.66">
      <ng-container
        *ngTemplateOutlet="formPrice; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="3.16" offset="0.5">
      <ng-container
        *ngTemplateOutlet="unitDescription; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="3.16" offset="0.5">
      <ng-container
        *ngTemplateOutlet="unitsPerCase; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="pimFlag">
    <ion-col size="3.66">
      <ng-container
        *ngTemplateOutlet="formPimClass; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formPimCategory; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formPimGroup; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mppMeasurementFlag">
    <ion-col size="3.66">
      <ng-container
        *ngTemplateOutlet="productYield; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mppMeasurementFlag">
    <ion-col size="12">
      <ng-container *ngTemplateOutlet="mppUnitsOfMeasure"></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<!-- ***** TABLET ***** -->
<ng-template #formTablet>
  <ion-row>
    <ion-col size="5.5">
      <ng-container
        *ngTemplateOutlet="formName; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="5.5" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formVendor; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col [size]="3.66">
      <ng-container
        *ngTemplateOutlet="formBrand; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formManufacture; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="3.66" offset="0.5" *ngIf="!isEditMode">
      <ng-container
        *ngTemplateOutlet="formPack; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col *ngIf="isEditMode" size="3.66" offset="0.5">
      <ng-container *ngTemplateOutlet="productNumber"></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col [size]="5.75" *ngIf="isEditMode">
      <ng-container
        *ngTemplateOutlet="formPack; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>

    <ion-col [size]="isEditMode ? 5.75 : 4" [offset]="isEditMode ? 0.5 : 0">
      <ng-container
        *ngTemplateOutlet="formNetWeight; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>

    <ion-col [size]="7.5" offset="0.5" *ngIf="!isEditMode">
      <ng-container
        *ngTemplateOutlet="formPrice; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col [size]="5.75" *ngIf="isEditMode">
      <ng-container
        *ngTemplateOutlet="formPrice; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="5.75" [offset]="isEditMode ? 0.5 : 0">
      <ng-container
        *ngTemplateOutlet="unitDescription; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="5.75" offset="0.5" *ngIf="!isEditMode">
      <ng-container
        *ngTemplateOutlet="unitsPerCase; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="isEditMode">
    <ion-col [size]="5.75">
      <ng-container
        *ngTemplateOutlet="unitsPerCase; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="5.75" offset="0.5" *ngIf="pimFlag">
      <ng-container
        *ngTemplateOutlet="formPimClass; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="!isEditMode && pimFlag">
    <ion-col size="3.66">
      <ng-container
        *ngTemplateOutlet="formPimClass; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formPimCategory; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col [size]="3.66" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formPimGroup; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="isEditMode && pimFlag">
    <ion-col size="5.75">
      <ng-container
        *ngTemplateOutlet="formPimCategory; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
    <ion-col size="5.75" offset="0.5">
      <ng-container
        *ngTemplateOutlet="formPimGroup; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mppMeasurementFlag">
    <ion-col size="3.66">
      <ng-container
        *ngTemplateOutlet="productYield; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mppMeasurementFlag">
    <ion-col size="12">
      <ng-container *ngTemplateOutlet="mppUnitsOfMeasure"></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<!-- ***** MOBILE ***** -->
<ng-template #formMobile>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formName; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formVendor; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formBrand; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isEditMode">
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="productNumber; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formManufacture; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formPack; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formNetWeight; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formPrice; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="unitDescription; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="unitsPerCase; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="pimFlag">
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formPimClass; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="pimFlag">
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formPimCategory; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="pimFlag">
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="formPimGroup; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mppMeasurementFlag">
    <ion-col size="12">
      <ng-container
        *ngTemplateOutlet="productYield; context: { form: usfProductForm }"
      ></ng-container>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mppMeasurementFlag">
    <ion-col size="12">
      <ng-container *ngTemplateOutlet="mppUnitsOfMeasure"></ng-container>
    </ion-col>
  </ion-row>
</ng-template>

<ion-content
  class="non-usf-content"
  [class.ion-content-modal-desktop]="platform === PlatformEnum.desktop"
  [class.ion-content-modal-tablet]="platform === PlatformEnum.tablet"
  [class.ion-content-modal-mobile]="platform === PlatformEnum.mobile"
>
  <!-- Page Content -->
  <ion-grid
    data-cy="non-usf-content-grid"
    [fixed]="true"
    [style.margin-bottom]="inFocus && isAndroidTouch ? '25rem' : null"
  >
    <form [formGroup]="usfProductForm">
      <ng-container
        *ngIf="platform === PlatformEnum.desktop"
        [ngTemplateOutlet]="formDesktop"
      ></ng-container>
      <ng-container
        *ngIf="platform === PlatformEnum.tablet"
        [ngTemplateOutlet]="formTablet"
      >
      </ng-container>
      <ng-container
        *ngIf="platform === PlatformEnum.mobile"
        [ngTemplateOutlet]="formMobile"
      ></ng-container>
    </form>
  </ion-grid>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform !== PlatformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="populate-inventory-cancel-button"
        [class.usf-outline-green-mobile-modal-button]="
          platform === PlatformEnum.mobile
        "
        [class.usf-outline-green-dsktp-tblt-modal-button]="
          platform !== PlatformEnum.mobile
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="populate-inventory-modal-next-button"
        [ngClass]="
          this.usfProductForm.valid && this.valuesDiffer
            ? platform === PlatformEnum.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : platform === PlatformEnum.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
        "
        (click)="submit()"
      >
        {{
          (isEditMode ? 'i18n.common.save' : 'i18n.common.submit') | translate
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
